import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/worldnewscentral/mm-client/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager" */ "/var/www/worldnewscentral/mm-client/node_modules/@mui/material/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/worldnewscentral/mm-client/node_modules/@mui/material/esm/Skeleton/Skeleton.js");
